import $ from 'jquery';
import Swiper from '../../node_modules/swiper/js/swiper.min.js';

$.addInit(function(context){
	var base = '.b-heroSlider';
	$(base, context).each(function(i, el){
		var component = $(this);
		var oval = component.find(base + '-oval');

		setTimeout(function() {
			new Swiper (el.querySelector('.b-heroSlider-container'), {
				slidesPerView: 1,
				spaceBetween: 20,
				slideClass: 'b-heroSlider-item',
				loop: true,
				watchOverflow: true,
				pagination : {
					el : el.querySelector('.swiper-pagination'),
					clickable: true,
				},
				navigation : {
					nextEl : el.querySelector('.b-heroSlider-btn_next'),
					prevEl : el.querySelector('.b-heroSlider-btn_prev')
				},
				on: {
					init: setImgPath,
					slideChangeTransitionStart: setImgPath
				}
			});

			function setImgPath() {
				var ovalImgPath = component.find('.swiper-slide-active').data('oval');
				oval.prop('src', ovalImgPath);
			}
		});
	});
});
